import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isCyberpunk, setIsCyberpunk] = useState(() => {
    const saved = localStorage.getItem('cyberpunk-mode');
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem('cyberpunk-mode', isCyberpunk);
  }, [isCyberpunk]);

  const toggleTheme = () => setIsCyberpunk((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ isCyberpunk, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
